import { api } from '../../../plugins/axios';

export class ShippingCompany {
	id = undefined;
	created_at = undefined;
	updated_at = undefined;
	shipping_company_id = undefined;
	credentials = undefined;
	active = undefined;
	is_linked = undefined;
	is_default = undefined;
	shipping_company = undefined;

	constructor(obj) {
		Object.keys(obj).forEach((key) => {
			this[key] = obj[key];
		});
	}

	static async getShippingCompanies(params) {
		const { data, totalRecords } = await api
			.get('/core/linked-shipping-companies', { params })
			.then((res) => ({
				data: res.data.result.items.data,
				totalRecords: res.data.result.items.total,
			}));
		return {
			data: data.map((item) => new ShippingCompany(item)),
			totalRecords,
		};
	}

	static getAllShippingCompanies(params) {
		return api
			.get('/core/linked-shipping-companies/list', {
				params: {
					per_page: 100,
                    ...params
				},
			})
			.then((res) => res.data.result.list);
	}

	static addCompany(data) {
		return api.post('core/linked-shipping-companies', data);
	}

	static updateRequest(id, data) {
		return api.put(`core/linked-shipping-companies/${id}`, data);
	}

	unlink() {
		this.is_linked = false;
		api.get(`/core/linked-shipping-companies/unlink/${this.id}`);
	}

	link() {
		this.is_linked = true;
		api.get(`/core/linked-shipping-companies/link/${this.id}`);
	}

	markAsDefault() {
		this.is_default = true;
		api.get(`/core/linked-shipping-companies/mark-as-default/${this.id}`);
	}
}
